
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"3.5","stroke":"#C7C7C7"}}),_c('path',{attrs:{"d":"M11.915 11H9l3.6-4v3.21c0 .354-.364.79-.685.79zM21 11v11.304c0 .383-.284.696-.632.696H9.632C9.284 23 9 22.687 9 22.304V11M12.6 7h7.796c.332 0 .604.313.604.696V11","stroke":"#908F8D","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#908F8D","stroke-linecap":"round","d":"M19 20.5h-6.2M19 17.5h-6.2"}})])
          )
        }
      }
    